window.ThemeOfferPricing = {
  groupItems(items) {
    const grouped = new Map();
    for (const item of items) {
      const key = JSON.stringify([item.id, item.selling_plan || '', item.properties || {}]);
      if (grouped.has(key)) grouped.get(key).quantity += item.quantity;
      else grouped.set(key, { ...item });
    }
    return [...grouped.values()];
  },

  calculate({ items, variants, discountType, discount, confirmed }) {
    let price = 0;
    let compare = 0;
    let available = items.length > 0;
    const quantities = new Map();
    for (const item of items) quantities.set(item.id, (quantities.get(item.id) || 0) + item.quantity);
    for (const item of items) {
      const variant = variants.find((entry) => entry.id === item.id);
      if (!variant) { available = false; continue; }
      const rule = variant.rule || {};
      const quantity = quantities.get(item.id);
      const minimum = rule.min || 1;
      const increment = rule.increment || 1;
      available &&= variant.available && quantity >= minimum && (quantity - minimum) % increment === 0;
      available &&= rule.max == null || quantity <= rule.max;
      available &&= variant.inventory == null || quantity <= variant.inventory;
      let unitPrice = variant.price;
      if (item.selling_plan) {
        const allocation = variant.plans?.find((plan) => plan.id === item.selling_plan);
        available &&= Boolean(allocation);
        unitPrice = allocation?.price ?? unitPrice;
      } else {
        for (const tier of [...(variant.breaks || [])].sort((left, right) => left.minimum_quantity - right.minimum_quantity)) {
          if (quantity >= tier.minimum_quantity) unitPrice = tier.price;
        }
      }
      price += unitPrice * item.quantity;
      compare += Math.max(variant.compare || 0, variant.price, unitPrice) * item.quantity;
    }
    const value = Math.max(0, Number(discount) || 0);
    if (confirmed) {
      if (discountType === 'percentage') price = Math.round(price * (1 - Math.min(100, value) / 100));
      if (discountType === 'fixed') price = Math.max(0, price - Math.round(value * 100));
    }
    return { price, compare, available };
  },

  writeItems(formData, items) {
    const properties = [...formData.entries()].filter(([key]) => key.startsWith('properties['));
    for (const key of [...formData.keys()]) {
      if (['id', 'quantity', 'selling_plan'].includes(key) || key.startsWith('properties[')) formData.delete(key);
    }
    items.forEach((item, index) => {
      formData.set(`items[${index}][id]`, item.id);
      formData.set(`items[${index}][quantity]`, String(item.quantity));
      if (item.selling_plan) formData.set(`items[${index}][selling_plan]`, item.selling_plan);
      if (!item.extra) for (const [key, value] of properties) formData.set(`items[${index}][${key.replace('[', '][')}`, value);
    });
  },
};
